import { itiMessageService } from './../services/iti-message-service';

import { VuexModule, Mutation, getModule, Module, Action } from 'vuex-module-decorators';
import { default as store } from './store';

@Module({
  namespaced: true,
  name: 'ItiLoadingModule',
  store,
  dynamic: true,
})
class ItiLoadingModule extends VuexModule {
  public loadingCount: number = 0;

  public get isLoading(): boolean {
    return this.loadingCount > 0;
  }

  @Mutation
  public enableLoading() {
    if (!this.isLoading) {
      itiMessageService.showLoading();
    }
    this.loadingCount++;
  }

  @Mutation
  public disableLoading() {
    this.loadingCount--;
    if (!this.isLoading) {
      itiMessageService.hideLoading();
    }
  }

}
export default getModule(ItiLoadingModule);
